import type { CreateSetup } from '@hvf/contracts'

export const fieldInformation: Partial<Record<keyof CreateSetup, string>> = {
  title: 'The name of your trade idea as it appears on The Sniper Circle. Be creative!',
  symbol: 'The ticker as it appears in TradingView eg: XAUUSD, AMZN',
  exchange: 'The exchange used for the Setup',
  description: 'Your assessment of the Setup',
  position: 'Whether trade direction is to the long or short side',
  duration:
    'Whether the chart candles in Setup Pattern view are more or less than daily. More than daily candlesticks results in log calculations, less than daily candlesticks is linear',
  market: 'The asset class of the Setup',
  image_macro: 'Image or URL for Macro timeframe of Setup',
  image_trend: 'Image or URL for Trend timeframe of Setup',
  image_pattern: 'Image or URL for Pattern timeframe of Setup',
  image_trigger: 'Image or URL for Trigger timeframe of Setup',
  image_volume_by_price:
    'Image or URL of Volume by Price of Setup (unrequired if using HVF Draw Tool)',
  image_time_stop:
    'Image or URL of Timestops of Setup (unrequired if using HVF Draw Tool)',
  high_1_price: 'Price level of inflection point',
  high_1_time: 'Time and date of inflection point',
  low_1_price: 'Price level of inflection point',
  low_1_time: 'Time and date of inflection point',
  high_2_price: 'Price level of inflection point',
  high_2_time: 'Time and date of inflection point',
  low_2_price: 'Price level of inflection point',
  low_2_time: 'Time and date of inflection point',
  high_3_price: 'Price level of inflection point',
  high_3_time: 'Time and date of inflection point',
  low_3_price: 'Price level of inflection point',
  low_3_time: 'Time and date of inflection point',
  first_in_new_trend: 'Tick if HVF Setup is First In A New Trend (FinT)',
  has_primer: 'Tick if HVF Setup has a primer ',
  trigger_date: 'Date the Setup is deemed to have triggered',
  time_stop: 'Date of final Timestop of Pattern',
}
